import z from "zod";

export const marketingKitSearchValidator = z.object({
  courseId: z.number().int().positive().optional(),
});
